const PREVENTED_TARGETS = [
  'input[type=text]',
  'input[type=password]',
  'input[type=search]',
  'input[type=email]',
  'textarea',
  '.ql-editor'
];

function createShortcutIndex(event) {
  let key = '';
  if (event.key === 'Shift' || event.shiftKey) key += 'shift';
  if (event.key === 'Control' || event.ctrlKey) key += 'ctrl';
  if (event.key === 'Meta' || event.metaKey) key += 'meta';
  if (event.key === 'Alt' || event.altKey) key += 'alt';
  if (event.key === 'ArrowUp') key += 'arrowup';
  if (event.key === 'ArrowLeft') key += 'arrowleft';
  if (event.key === 'ArrowRight') key += 'arrowright';
  if (event.key === 'ArrowDown') key += 'arrowdown';
  if (event.key === 'AltGraph') key += 'altgraph';
  if (event.key === 'Escape') key += 'esc';
  if (event.key === 'Enter') key += 'enter';
  if (event.key === 'Tab') key += 'tab';
  if (event.key === ' ') key += 'space';
  if (event.key === 'PageUp') key += 'pageup';
  if (event.key === 'PageDown') key += 'pagedown';
  if (event.key === 'Home') key += 'home';
  if (event.key === 'End') key += 'end';
  if (event.key === 'Delete') key += 'del';
  if (event.key === 'Backspace') key += 'backspace';
  if (event.key === 'Insert') key += 'insert';
  if (event.key === 'NumLock') key += 'numlock';
  if (event.key === 'CapsLock') key += 'capslock';
  if (event.key === 'Pause') key += 'pause';
  if (event.key === 'ContextMenu') key += 'contextmenu';
  if (event.key === 'ScrollLock') key += 'scrolllock';
  if (event.key === 'BrowserHome') key += 'browserhome';
  if (event.key === 'MediaSelect') key += 'mediaselect';
  if ((event.key && event.key !== ' ' && event.key.length === 1) || /F\d{1,2}|\//g.test(event.key)) {
    key += event.key.toLowerCase();
  }
  return key;
}

function encodeShortcut(shortcut) {
  const modifierKeys = ['shift', 'ctrl', 'meta', 'alt'];
  let key = '';
  if (shortcut.includes('shift')) key += 'shift';
  if (shortcut.includes('ctrl')) key += 'ctrl';
  if (shortcut.includes('meta')) key += 'meta';
  if (shortcut.includes('alt')) key += 'alt';
  key += shortcut.filter(item => !modifierKeys.includes(item)).join('');
  return key;
}

export function matchesPreventedShortcutTarget(target = document.activeElement) {
  return !!target && typeof target.matches === 'function' && PREVENTED_TARGETS.some(selector => target.matches(selector));
}

export function findShortcutKey(event, mapping) {
  if (!mapping || matchesPreventedShortcutTarget()) {
    return null;
  }

  const eventKey = createShortcutIndex(event);
  return Object.keys(mapping).find(key => encodeShortcut(mapping[key]) === eventKey) || null;
}

export function preventShortcutEvent(event) {
  event.preventDefault();
  event.stopPropagation();
}
